import { JsonEditor, JsonEditorProps } from '@components/json-editor';

import { FormFieldProps, FormValidatorType } from './types';
import { useFormField } from './use-form-field';

export type FormJsonEditorProps<T = unknown> = FormFieldProps<JsonEditorProps, T>;

export function FormJsonEditor<T>(props: FormJsonEditorProps<T>) {
  const validators: FormValidatorType[] = ['json', ...(props.validators ?? [])];
  const formFieldProps = useFormField({ ...props, validators });

  return <JsonEditor {...props} {...formFieldProps} />;
}
